var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "fill-width d-flex align-center"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('v-text-field', _vm._b({
    staticClass: "mt-0",
    attrs: {
      "placeholder": "Address line 1"
    },
    model: {
      value: _vm.address.line_1,
      callback: function ($$v) {
        _vm.$set(_vm.address, "line_1", $$v);
      },
      expression: "address.line_1"
    }
  }, 'v-text-field', _vm.$attrs, false)), _c('v-text-field', _vm._b({
    staticClass: "mt-0",
    attrs: {
      "placeholder": "Address line 2"
    },
    model: {
      value: _vm.address.line_2,
      callback: function ($$v) {
        _vm.$set(_vm.address, "line_2", $$v);
      },
      expression: "address.line_2"
    }
  }, 'v-text-field', _vm.$attrs, false)), _c('div', {
    staticClass: "d-flex mx-n1"
  }, [_c('v-text-field', _vm._b({
    staticClass: "mt-0 mx-1",
    staticStyle: {
      "min-width": "unset"
    },
    attrs: {
      "placeholder": "City"
    },
    model: {
      value: _vm.address.city,
      callback: function ($$v) {
        _vm.$set(_vm.address, "city", $$v);
      },
      expression: "address.city"
    }
  }, 'v-text-field', _vm.$attrs, false)), _c('v-text-field', _vm._b({
    staticClass: "mt-0 mx-1 flex-shrink-0",
    staticStyle: {
      "width": "32px"
    },
    attrs: {
      "placeholder": "State"
    },
    model: {
      value: _vm.address.region,
      callback: function ($$v) {
        _vm.$set(_vm.address, "region", $$v);
      },
      expression: "address.region"
    }
  }, 'v-text-field', _vm.$attrs, false)), _c('v-text-field', _vm._b({
    staticClass: "mt-0 mx-1 flex-shrink-0",
    staticStyle: {
      "width": "64px"
    },
    attrs: {
      "placeholder": "Zip code"
    },
    model: {
      value: _vm.address.postal_code,
      callback: function ($$v) {
        _vm.$set(_vm.address, "postal_code", $$v);
      },
      expression: "address.postal_code"
    }
  }, 'v-text-field', _vm.$attrs, false)), _c('div', {
    staticClass: "flex-grow-0 mx-1"
  }, [_c('country-flag', {
    staticClass: "mb-n1 mx-n1",
    staticStyle: {
      "transform": "scale(.8)"
    },
    attrs: {
      "country": _vm.address.country_code
    }
  })], 1)], 1)], 1), _vm.$slots['append-outer'] ? _c('div', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_vm._t("append-outer")], 2) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }